module.exports = __webpack_public_path__ + "img/2.ae10b125.jpg";